<template>

	<section v-if="mutatedNote" class="form-section form-section-print-view">

		<!-- Subject -->
		<h4>
			<span v-if="'subject' in mutatedNote">Subject: {{ note.subject }}</span>
		</h4>

		<!-- Created At Info -->
		<div class="field-container">
			<div class="field field-type-text">
				<h5>Created at</h5>
				<div class="pre-field">{{ mutatedNote.createdAt }}</div>
			</div>
		</div>

		<!-- Updated By/At Info -->
		<div class="field-container">
			<div class="field field-type-text">
				<h5>Updated by</h5>
				<div class="pre-field">
					{{ mutatedNote.updatedBy }} on {{ mutatedNote.updatedAt }}
				</div>
			</div>
		</div>

		<!-- Note Text -->
		<div class="field-container">
			<div class="field field-type-static-paragraph">
				<h5 class="mb-1">Note Text</h5>
				<div v-if="'note' in mutatedNote" class="pre-field" v-html="stripInlineEventHandlers(mutatedNote.note)"></div>
			</div>
		</div>

		<!-- Image Attachments -->
		<!-- NOTE: at this time, notes only accept image attachments.
				 This module only works with images (does not support other file types) -->
		<div v-if="'UploadFile' in mutatedNote && mutatedNote.UploadFile.length > 0">
			<div class="field field-type-attachments">

				<h5>Image Attachments</h5>

				<image-thumb-list :images="mutatedNote.images"
					:readonly="true"
					max-size="200px">
				</image-thumb-list>

			</div>
		</div>

	</section>
</template>


<script type="text/javascript">

import FileListItem from "@/components/FileListItem"
import ImageThumbList from "@/components/ImageThumbList"

export default {
	name: "JobNote",
	components: {
		FileListItem,
		ImageThumbList
	},
	props: ["note"],
	computed: {
		noteImages() {
			return this.mutatedNote.UploadFile
		},
		mutatedNote() {

			// Make new computed note
			let mutated = Object.assign({}, this.note)

			if ('created_at' in this.note && this.note.created_at)
				mutated.createdAt = this.formatDateTimeToLocal(this.note.created_at, "full-date-time")

			if ('updated_at' in this.note && this.note.updated_at)
				mutated.updatedAt = this.formatDateTimeToLocal(this.note.updated_at, "full-date")

			if ('UpdatedBy' in this.note && this.note.UpdatedBy)
				mutated.updatedBy = this.note.UpdatedBy.first_name + " " + this.note.UpdatedBy.last_name

			if ("UploadFile" in this.note)
				this.note.UploadImage = this.note.UploadFile

			if ('UploadImage' in this.note) {

				let userIsVerified = 'id' in this.$store.userDetails

				mutated.images = this.note.UploadImage.map(file => {

					// User is verified
					if (file.thumb_filename)
						if (userIsVerified)
							file.thumbUrl = this.$store.apiRoot + 'resources/files/' + this.$store.sessionToken + '/' + file.thumb_filename
						else
							file.thumbUrl = this.$store.apiRoot + 'resources/files/sharing/' + file.thumb_filename
					else
						file.thumbUrl = false


					if ('id' in this.$store.userDetails)
						file.fullUrl = this.$store.apiRoot + 'resources/files/' + this.$store.sessionToken + '/' + file.filename
					else
						file.fullUrl = this.$store.apiRoot + 'resources/files/sharing/' + file.filename

					return file
				})
			}
			return mutated
		}
	}
}
</script>


<style type="text/css" scoped>

article {
	max-width: 1000px;
	margin: auto;
}

.form-section pre {
	margin-bottom: 0;
}

/* Subject Box */
.form-section-print-view h4 {
	padding: 15px;
	background: #6c757d;
	color: white;
	margin-left: -15px;
	margin-right: -15px;
	text-decoration: none;
}



.form-section-print-view .field-container {
	border-bottom: 1px solid #e0e0e07a;
}

.form-section-print-view .field {
	padding-top: 10px;
	padding-bottom: 10px;
}

.form-section-print-view .field:last-child {
	border-bottom: none;
}

.form-section-print-view .field h5 {
	margin-bottom: 0;
}

.form-section-print-view .field.field-type-text {
	display: flex;
}

.form-section-print-view .field.field-type-text h5 {
	width: 100%;
}

.form-section-print-view .field.field-type-text > div {
	width: 80%;
	text-align: right;
}

.field.field-type-static-paragraph > div {
	width: 100%;
	margin-top: 5px;
	font-size: 100%;
}

.field.field-type-attachments > div {
	width: 100%;
	margin-top: 14px;
	padding: 0 6px;
	font-size: 100%;
}

.form-section-print-view .pre-field {
	font-size: 110%;
	font-family: inherit;
	word-wrap: break-word;
}


</style>
